import api from '@/config/api'
import vuex from '@/store'
import axios from 'axios'

// const headers = {
//     'x-rapidapi-host': 'vanitysoft-boundaries-io-v1.p.rapidapi.com',
//     'x-rapidapi-key': 'secret'
// }

export default {
  getZipsByCenterRadius({ lat, lng }, radius = 30) {
    return api.get(`/v2/newsdesk/location/zipcodes/${lat}/${lng}?radius=${radius}`)
    // return axios.get(
    //     `https://vanitysoft-boundaries-io-v1.p.rapidapi.com/reaperfire/rest/v1/public/boundary/zipcode/location?latitude=${lat}&longitude=${lng}&radius=${radius}`,
    //     { headers }
    // );
  },
  getBoundaries(zips = []) {
    return api.post(`/v2/newsdesk/zipcodes/boundaries?combine=false`, zips)
    // return axios.post(
    //     `https://vanitysoft-boundaries-io-v1.p.rapidapi.com/rest/v1/public/boundary/zipcode?combine=false`,
    //     zips,
    //     { headers }
    // );
  }
}
